module.exports = __webpack_public_path__ + "img/gallery.1dc76218.png";